/**
 * Public note links. The web twin of mobile's `features/notes/share.ts` — both build
 * the same `/public/note/:id` URL, which the web serves and the mobile app deep-links.
 */

export const publicNoteUrl = (noteId: number, origin: string = window.location.origin): string =>
  `${origin.replace(/\/+$/, '')}/public/note/${noteId}`;

/** The link without its scheme, for showing in a tight row. */
export const displayUrl = (url: string): string => url.replace(/^[a-z]+:\/\//i, '');
